export const MAX_SELECTABLE_METRICS = 8;
